module.exports = __webpack_public_path__ + "static/img/honorPadX2_128.59c6c65e.png";